import { MiddlewareStore } from 'store/createStore'
import { setEndChatConfirm } from 'store/app/app.actions'
import { postMessageToParent, setCSSVar } from 'utils'
import { SmartagentChatWebsocketType } from '@missionlabs/smartagent-bchat'

import MessagesTypes from 'store/messages/messages.types'

let listening = false
let ws: SmartagentChatWebsocketType | null
let storeRef: MiddlewareStore | null = null

const listener = async (message: MessageEvent) => {
    if (!message.data || message.data.type !== 'smartagent' || !storeRef) return

    switch (message.data.event) {
        case 'loader-close-chat':
            if (!storeRef.getState().app.ended) {
                storeRef.dispatch<any>(setEndChatConfirm(true))
            } else {
                invalidateChatLoaderWebsocket()
                postMessageToParent('smartagent-minimise-loader', {})
            }
            return
        case 'update-contact':
            if (!window.bchat) {
                console.log('Error reading message: ', message)
                throw new Error(`No websocket`)
            }
            console.log('message received', message)
            if (!message.data.data) {
                postMessageToParent('update-contact-error', { error: 'No payload provided' })
                return
            }
            const data = {
                ...message.data.data,
                contactId: storeRef.getState().app.contactId,
            }
            window.bchat.updateContact(data)
            return
        case 'download-chat-transcript': {
            return storeRef.dispatch({
                type: MessagesTypes.GET_TRANSCRIPT,
            })
        }
        case 'post-css-variables':
            console.log('got css variables from loader', message.data.data)

            Object.entries(message.data.data).forEach(([varName, varValue]) =>
                setCSSVar('--sa-' + varName, varValue as string),
            )
            return
        default:
            return
    }
}

const listenToLoaderMessages = async (store: MiddlewareStore) => {
    storeRef = store
    postMessageToParent('smartagent-get-css-variables', {})

    if (listening) {
        window.removeEventListener('message', listener)
        listening = false
    }

    if (!listening) {
        window.addEventListener('message', listener)
    }
    listening = true

    return listener
}

export const setChatLoaderWebsocket = (websocket: SmartagentChatWebsocketType) => {
    ws = websocket
}

export const invalidateChatLoaderWebsocket = () => {
    ws = null
}

export default listenToLoaderMessages
